import { fileUrlQueryAtom } from '@rematter/modules/customer-portal/_graphql/queryFileUrl';
import { getDefaultStore, Getter } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import keyBy from 'lodash/keyBy';

import { ParameterizedQueryAtom } from '~/shared/providers/api/createQueryAtomFactory';

export const $generateFilesUrls = fileUrlQueryAtom();

export const filesWithUrlsAtom = <TVariables>(
  getConfig: (get: Getter) => {
    variables: TVariables;
    skip?: boolean;
    photosAtom: ParameterizedQueryAtom<
      TVariables,
      { id: string; metadata?: Record<string, unknown> | null }[],
      { id: string; metadata?: Record<string, unknown> | null }[]
    >;
  },
) =>
  atomWithQuery((get) => {
    const config = getConfig(get);
    return {
      queryKey: ['loadMaterialPhotosWithUrls', config.variables],
      queryFn: async () => {
        const store = getDefaultStore();

        const photos = await get(config.photosAtom).fetch(config.variables);

        const filesWithUrls = await store.set($generateFilesUrls, {
          fileIds: photos?.map((it) => it.id) ?? [],
        });

        const urlsByFileId = keyBy(filesWithUrls, (it) => it.fileId);

        return (
          photos?.map((photo) => ({
            id: photo.id,
            url: urlsByFileId[photo.id]?.url ?? '',
            name:
              (photo.metadata?.name as string | undefined) ??
              photo.id.substring(0, 8),
          })) ?? []
        );
      },
      enabled: !config.skip,
    };
  });
